import Button from "@/components/Button";
import Dialog from "@/components/Dialog";
import { useCallback, useEffect, useState } from "react";

interface DownloadQRCodeDialogProps {
  open: boolean;
  onClose: () => void;
  url: string;
}

export default function DownloadQRCodeDialog({ open, onClose, url }: DownloadQRCodeDialogProps) {
  const [loading, setLoading] = useState(true);
  const [qrCode, setQrCode] = useState("");

  const getQrCode = useCallback(async () => {
    setLoading(true);
    try {
      // Import the QR code utility dynamically to avoid SSR issues
      const { createQRCode } = await import("@/components/QrComponents/utils/qrCodeGenerator");

      // Download the QR code
      const canvas = await createQRCode(url);
      const imageUrl = canvas.toDataURL("image/png");

      setQrCode(imageUrl);
      setLoading(false);
    } catch (error) {
      console.error("Error downloading QR code:", error);
    }
  }, [url]);

  useEffect(() => {
    if (open && url) {
      getQrCode();
    }
  }, [url, open, getQrCode]);

  return (
    <Dialog
      open={open}
      onClosed={onClose}
      headline="Download QR Code"
      actions={
        <Button variant="text" onClick={onClose}>
          Close
        </Button>
      }
    >
      <div className="flex items-center justify-center overflow-auto">
        {loading ? (
          <div className="w-4 h-4 border-2 border-gray-300 border-t-blue-600 rounded-full animate-spin" />
        ) : (
          <img src={qrCode!} className="max-h-[300px]" />
        )}
      </div>
    </Dialog>
  );
}
